import { encode } from "@msgpack/msgpack";
export const createSocketMessage = (message, isMsgpack) => isMsgpack ?
    encode(Object.assign({ jsonrpc: "2.0", locale: message === null || message === void 0 ? void 0 : message.locale }, message)) :
    JSON.stringify(Object.assign({ jsonrpc: "2.0", locale: message === null || message === void 0 ? void 0 : message.locale }, message));
//# sourceMappingURL=createSocketMesssage.js.map